<template>
  <ContentBlock style="padding: 0 10px 20px 10px;">
    <TableWithPagination class="special" :leftToolbar="tableButtons" :columnList="columnList" :tableData="targetLists" :toolBar="toolBar"
      :sortInfo.sync="lastAccessSortInfo" tableBorder="default" :showRightToolbar="true" :pagination.sync="pagination"
      @size-change="handleChangePage" @current-change="handleChangePage" @sort-change="handleSortChange"
      :highHoverRow="false" :highlightRow="false" />
    <el-drawer title="高级筛选" width="500" direction="rtl" :modal-append-to-body="false" :visible.sync="isShow"
      :close-on-click-modal="false" @closed="isShow = false">
      <el-form label-width="auto" label-position="right" style="margin-top: 20px;padding: 10px;">
        <el-row>
          <el-col :span='24'>
            <el-form-item label="用户名称">
              <el-input placeholder="请输入" v-model.trim="form.employeeName" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="手机号">
              <el-input placeholder="请输入" v-model.trim="form.phoneNumber" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="关联企业">
              <el-input placeholder="请输入" v-model.trim="form.tenantName" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="用户访问次数(网页端)">
              <el-select size="small" placeholder="判断符" style="width: 30%;" v-model="form.pcAccessTimesComparisonOperator">
                <el-option :label="exp.label" :value="exp.value" :key="exp.value" v-for="exp in explains"></el-option>
              </el-select>
              <el-input style="width: 70%;" size="small" placeholder="请输入" type="number" v-model="form.pcAccessTimes"/>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="用户访问次数(小程序)">
              <el-select size="small" placeholder="判断符" style="width: 30%;" v-model="form.miniAccessTimesComparisonOperator">
                <el-option :label="exp.label" :value="exp.value" :key="exp.value" v-for="exp in explains"></el-option>
              </el-select>
              <el-input style="width: 70%;" size="small" placeholder="请输入" type="number" v-model="form.miniAccessTimes"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center;">
        <el-button @click="handleEmpty">清空</el-button>
        <el-button type="primary" @click="handleQuery">查询</el-button>
      </div>
    </el-drawer>
  </ContentBlock>
</template>
<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import * as dayjs from 'dayjs';
import icRefresh from '@/assets/table/ic_refresh.svg';
import icAdvanceSearch from '@/assets/table/ic_advanceSearch.svg';
import { explains } from '../config';
import { employeeAccessStatistics } from '@/api/statistics';

const today = new Date();
const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
const yesterdayFormat = dayjs(yesterday * 1).format('YYYY-MM-DD');

export default {
  components: {
    TableWithPagination,
  },
  mixins: [TablePaginationMixin],
  computed: {
    toolBar () {
      let currentLists = [
        {
          type: 'custom',
          render: () => {
            return (
              <el-input placeholder='请输入用户名称' style='width:250px;' v-model={this.outform.employeeName}>
                <el-button slot="suffix" icon="el-icon-search" onClick={this.handleSearch} style='position: absolute;height: 100%;right: -5px;top: 0;'>
                </el-button>
              </el-input>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleAdvancedSearch}>
                <img style='font-size:14px;width:15px;height:15px;' src={icAdvanceSearch} />
              </vxe-button>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleReset}>
                <img style='font-size:14px;width:15px;height:15px;' src={icRefresh} />
              </vxe-button>
            );
          },
        },
      ];
      return currentLists;
    },
    columnList () {
      const cols = [
        {
          tooltip: true,
          label: '用户名称',
          minWidth: '100px',
          width: '',
          prop: 'employeeName',
        },
        {
          tooltip: true,
          label: '手机号',
          minWidth: '100px',
          width: '',
          prop: 'phoneNumber',
        },
        {
          tooltip: true,
          label: '关联企业',
          minWidth: '200px',
          width: '',
          prop: 'tenantName',
          render: (h, {row}) => {
            let actions = [];
            if (row.isPersonal) {
              actions.push(<span>个人</span>);
            } else {
              actions.push(<span>{row.tenantName}</span>);
            }
            return <div>{...actions}</div>;
          },
        },
        {
          tooltip: true,
          label: '用户访问次数(网页端)',
          minWidth: '150px',
          width: '',
          prop: 'pcAccessTimes',
        },
        {
          tooltip: true,
          label: '用户访问次数(小程序)',
          minWidth: '130px',
          width: '',
          prop: 'miniAccessTimes',
        },
        {
          tooltip: true,
          label: '总访问次数',
          minWidth: '130px',
          width: '',
          sortable: true,
          prop: 'totalAccessTimes',
        },
        {
          tooltip: true,
          label: '最后访问时间(网页端)',
          minWidth: '130px',
          width: '',
          prop: 'pcLastAccessTime',
          format: (v) => {
            return this.formatTime(v);
          },
        },
        {
          tooltip: true,
          label: '最后访问时间(小程序)',
          minWidth: '130px',
          width: '',
          prop: 'miniLastAccessTime',
          format: (v) => {
            return this.formatTime(v);
          },
        },
      ];
      return cols;
    },
  },
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          let curDate = (new Date()).getTime();
          let three = 90 * 24 * 3600 * 1000;
          let threeMonths = curDate - three;
          return time.getTime() > Date.now() || time.getTime() < threeMonths;
        },
      },
      tableButtons: [
        {
          type: 'custom',
          render: () => {
            return (
              <div>
                数据统计时间：
              <el-date-picker
                v-model={this.outform.accessDate}
                type='daterange'
                range-separator='至'
                start-placeholder='开始日期'
                end-placeholder='结束日期'
                value-format='yyyy-MM-dd'
                picker-options={this.pickerOptions}
                onChange={this.handleChangeDate}>
              </el-date-picker>
              </div>
            );
          },
        },
      ],
      explains,
      outform: {
        accessDate: [yesterdayFormat, yesterdayFormat],
        accessDateEnd: yesterdayFormat,
        accessDateStart: yesterdayFormat,
        employeeName: '',
        miniAccessTimes: null,
        miniAccessTimesComparisonOperator: 1,
        pcAccessTimes: null,
        pcAccessTimesComparisonOperator: 1,
        phoneNumber: '',
        tenantName: '',
      },
      form: {
        accessDate: [yesterdayFormat, yesterdayFormat],
        accessDateEnd: yesterdayFormat,
        accessDateStart: yesterdayFormat,
        employeeName: '',
        miniAccessTimes: null,
        miniAccessTimesComparisonOperator: 1,
        pcAccessTimes: null,
        pcAccessTimesComparisonOperator: 1,
        phoneNumber: '',
        tenantName: '',
      },
      targetLists: [],
      isShow: false,
    };
  },
  methods: {
    formatTime (v) {
      let ret = '';

      if (v) {
        ret = dayjs(v * 1).format('YYYY-MM-DD HH:mm');
      }

      return ret;
    },
    handleEmpty () {
      this.form = this.$options.data().form;
    },
    handleChangeDate (v) {
      if (v?.length) {
        this.outform.accessDateStart = v[0];
        this.outform.accessDateEnd = v[1];
      } else {
        this.outform.accessDateStart = '';
        this.outform.accessDateEnd = '';
      }
      this.handleSortChange();
    },
    handleChangePage (page) {
      this.outform = { ...this.outform, ...page};
      this.getTargetLists();
    },
    handleQuery () {
      this.pagination.currentPage = 1;

      this.getTargetLists(this.form);

      this.$nextTick(() => {
        this.outform = { ...this.form };
        this.isShow = false;
      });
    },
    handleSearch () {
      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    handleAdvancedSearch () {
      this.form = { ...this.outform };

      this.isShow = true;
    },
    handleReset () {
      this.outform = this.$options.data().outform;

      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    handleSortChange () {
      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    getTargetLists (form = this.outform) {
      const params = {
        ...form,
        employeeName: form.employeeName.trim(),
        miniAccessTimes: form.miniAccessTimes,
        pcAccessTimes: form.pcAccessTimes,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        orderBy: [this.lastAccessSortInfo],
      };

      delete params.accessDate;

      employeeAccessStatistics(params).then(({ body }) => {
        this.targetLists = body?.list || [];

        this.pagination.total = body?.total || 0;
      });
    },
  },
  created () {
    this.handleSearch();
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}

/deep/.vxe-tools--wrapper {
  display: flex;
  justify-content: space-between;

  &>.el-button {
    margin-left: 0.5em;
  }

  &>div.el-input {
    margin-left: 0.5em;
  }

  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .vxe-tools--operate {
  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .action {
  color: #409EFF;
  cursor: pointer;

  &:hover {
    color: rgba(64, 158, 255, 0.7);
    text-decoration: underline;
  }
}

/deep/ .el-date-editor.el-input {
  width: -webkit-fill-available;
}
</style>
